import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Form, Button, Dropdown } from 'semantic-ui-react';

import { saveCampaign, editEntityField } from '../../../actions';

class CampaignEditor extends Component {

    handleSubmit = (event) => {
        this.props.saveCampaign(this.props.loyaltyProgramId, this.props.entity);
        event.preventDefault();
    }

    render() {
        if (!this.props.entity) {
            return null;
        }

        const campaign = this.props.entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                
                <Form.Field>
                    <label>{i18next.t('name')}</label>
                    <input
                        placeholder={i18next.t('name')}
                        value={campaign.name || ''}
                        onChange={({ target }) => this.props.editEntityField('name', target.value)}
                        required
                    />
                </Form.Field>
                
                <Form.Field>
                    <label>{i18next.t('description')}</label>
                    <input
                        placeholder={i18next.t('description')}
                        value={campaign.description || ''}
                        onChange={({ target }) => this.props.editEntityField('description', target.value)}
                        required
                    />
                </Form.Field>

                <Form.Group>
                    <Button type='submit' primary floated="right">
                        {i18next.t('save')}
                    </Button>
                </Form.Group>

            </Form>
        );
    }
}

CampaignEditor.propTypes = {
    loyaltyProgramId: PropTypes.any,
    saveCampaign: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, { saveCampaign, editEntityField })(CampaignEditor);
